module.exports = __webpack_public_path__ + "static/media/icon_monotributista_active.0cc2f28a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_monotributista_active.svg
// module id = 627
// module chunks = 0